import { render } from "./SingleItem.vue?vue&type=template&id=426a2575&scoped=true"
import script from "./SingleItem.vue?vue&type=script&lang=js"
export * from "./SingleItem.vue?vue&type=script&lang=js"

import "./SingleItem.vue?vue&type=style&index=0&id=426a2575&lang=scss&scoped=true"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426a2575"]])

export default __exports__